import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';
import { isControlPlaneHost } from '../utils/runtime';

interface SuperadminRouteProps {
  children: React.ReactNode;
}

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #666;
`;

const SuperadminRoute: React.FC<SuperadminRouteProps> = ({ children }) => {
  const { isAuthenticated, isSuperuser, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingContainer>Carregando...</LoadingContainer>;
  }

  if (!isControlPlaneHost()) {
    return <Navigate to="/admin" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperuser) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default SuperadminRoute;
